import { put, call, all, takeLatest } from 'redux-saga/effects'
import { PaymentTemplateActions, FETCH_PAYMENT_TEMPLATES } from './actions'
import { fetchAllPaymentTemplates } from '../../api/paymentTemplate'
// import { PaymentTemplateValidationResult, PaymentTemplate } from './types'

// const VALIDATION_DEBOUNCE_TIME = 250

export function* loadPaymentTemplates() {
  try {
    const { data } = yield call(fetchAllPaymentTemplates)
    yield put(PaymentTemplateActions.fetchPaymentTemplatesSuccess(data))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* rootSaga() {
  yield all([takeLatest(FETCH_PAYMENT_TEMPLATES, loadPaymentTemplates)])
}
